import React, { useState } from "react";
import { toast } from "react-toastify";
import useInvoiceReview from "./useInvoiceReview.js";
import InvoiceReviewFilters from "./invoiceReviewFilters.jsx";
import InvoiceReviewTable from "./invoiceReviewTable.jsx";
import BulkActionDialog from "./bulkActionDialog.jsx";
import CheckRegisterReviewTab from "./checkRegisterReviewTab.jsx";
import "./invoiceReview.scss";

const InvoiceReview = () => {
    const [activeTab, setActiveTab] = useState("invoices");

    const {
        items,
        nextToken,
        isLoading,
        isError,
        filters,
        setFilters,
        applyFilters,
        clearFilters,
        pageSize,
        onPageSizeChange,
        tokenStack,
        goNext,
        goPrevious,
        selectedIds,
        toggleRowSelection,
        toggleAllSelection,
        clearSelection,
        actionMutation,
        bulkActionMutation,
    } = useInvoiceReview();

    const [bulkDialog, setBulkDialog] = useState(null);

    if (isError) {
        toast.error("Service unavailable.");
    }

    const handleAccept = (item) => {
        actionMutation.mutate({ sk: item.sk, accountHccId: item.accountHccId, status: "accepted" });
    };

    const handleReject = (item) => {
        actionMutation.mutate({ sk: item.sk, accountHccId: item.accountHccId, status: "rejected" });
    };

    const selectedInvoices = bulkDialog
        ? items.filter((item) => selectedIds.has(item.sk))
        : [];

    const handleBulkConfirm = ({ sks, status }) => {
        bulkActionMutation.mutate({ sks, status });
        setBulkDialog(null);
    };

    return (
        <div className="container invoice-review">
            <p className="title">Invoice Review</p>
            <p className="sub-title">
                HRP-generated invoices and check-registers pending approval.
            </p>

            <div className="invoice-review__tabs">
                <button
                    type="button"
                    className={`invoice-review__tab${activeTab === "invoices" ? " invoice-review__tab--active" : ""}`}
                    onClick={() => setActiveTab("invoices")}
                >
                    Review Invoices
                </button>
                <button
                    type="button"
                    className={`invoice-review__tab${activeTab === "checkRegisters" ? " invoice-review__tab--active" : ""}`}
                    onClick={() => setActiveTab("checkRegisters")}
                >
                    Review Check-Registers
                </button>
            </div>

            {/* CSS hide/show — NOT unmount — preserves each tab's hook state (filters, pagination) on switch */}
            <div hidden={activeTab !== "invoices"}>
                {selectedIds.size > 0 && (
                    <div className="invoice-review__bulk-bar">
                        <span className="invoice-review__bulk-count">{selectedIds.size} selected</span>
                        <button
                            type="button"
                            className="invoice-review__bulk-btn invoice-review__bulk-btn--accept"
                            onClick={() => setBulkDialog("accept")}
                        >
                            Bulk Accept
                        </button>
                        <button
                            type="button"
                            className="invoice-review__bulk-btn invoice-review__bulk-btn--reject"
                            onClick={() => setBulkDialog("reject")}
                        >
                            Bulk Reject
                        </button>
                    </div>
                )}

                <InvoiceReviewFilters
                    filters={filters}
                    setFilters={setFilters}
                    onApply={applyFilters}
                    onClear={clearFilters}
                />

                <InvoiceReviewTable
                    items={items}
                    isLoading={isLoading}
                    selectedIds={selectedIds}
                    onToggleRow={toggleRowSelection}
                    onToggleAll={toggleAllSelection}
                    onAccept={handleAccept}
                    onReject={handleReject}
                    pageSize={pageSize}
                    onPageSizeChange={onPageSizeChange}
                    nextToken={nextToken}
                    tokenStack={tokenStack}
                    onNext={goNext}
                    onPrevious={goPrevious}
                />

                {bulkDialog && (
                    <BulkActionDialog
                        selectedInvoices={selectedInvoices}
                        action={bulkDialog}
                        onConfirm={handleBulkConfirm}
                        onCancel={() => setBulkDialog(null)}
                    />
                )}
            </div>

            <div hidden={activeTab !== "checkRegisters"}>
                <CheckRegisterReviewTab />
            </div>
        </div>
    );
};

export default InvoiceReview;
